import { render } from "./LaborHistory.vue?vue&type=template&id=f6d06fe6&scoped=true"
import script from "./LaborHistory.vue?vue&type=script&lang=js"
export * from "./LaborHistory.vue?vue&type=script&lang=js"

import "./LaborHistory.vue?vue&type=style&index=0&id=f6d06fe6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6d06fe6"]])

export default __exports__